import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { TrafficCone, Sofa, MapPinned, Building2, Truck, Check, Phone, MessageCircle } from "lucide-react";
import PageHero from "@/components/PageHero";
import { SITE, SERVICES } from "@/data/site";

const ICONS = { TrafficCone, Sofa, MapPinned, Building2, Truck };

export default function Services() {
  const { hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const el = document.getElementById(hash.slice(1));
      if (el) setTimeout(() => el.scrollIntoView({ behavior: "smooth", block: "start" }), 60);
    }
  }, [hash]);

  return (
    <div data-testid="services-page">
      <PageHero
        eyebrow="Our Services"
        title="Five practices under one accountable roof."
        subtitle="Road & building construction, Vastu-aligned interior design, plot & flat sales and building-materials trading — orchestrated by a single team so your project moves faster with fewer surprises."
        image="/images/building-construction.jpeg"
        crumbs={[{ label: "Home", to: "/" }, { label: "Services" }]}
      />

      <section className="bg-white">
        {SERVICES.map((s, idx) => {
          const Ic = ICONS[s.icon];
          const reverse = idx % 2 === 1;
          return (
            <div key={s.id} id={s.id} className={`border-b border-[#E5E7EB] py-20 md:py-28 ${idx === 0 ? "pt-24 md:pt-32" : ""}`} data-testid={`service-section-${s.id}`}>
              <div className="max-w-7xl mx-auto px-6 lg:px-10 grid md:grid-cols-12 gap-12 items-center">
                <div className={`md:col-span-6 ${reverse ? "md:order-2" : ""}`}>
                  <div className="overflow-hidden">
                    <img src={s.img} alt={s.title} className="w-full h-[420px] md:h-[520px] object-cover" style={{ objectPosition: "center 15%" }}/>
                  </div>
                </div>
                <div className="md:col-span-6">
                  <div className="flex items-center gap-4 mb-6">
                    <div className="w-12 h-12 grid place-items-center bg-[#0B162C] text-[#C5A059]"><Ic size={20}/></div>
                    <span className="text-xs uppercase tracking-[0.28em] text-[#C5A059]">0{idx+1} / 0{SERVICES.length}</span>
                  </div>
                  <h2 className="font-serif-display text-4xl md:text-5xl leading-[1.05] text-[#0B162C]">{s.title}</h2>
                  <p className="mt-5 text-[17px] leading-[1.85] text-[#5C6B7B]">{s.description}</p>
                  <ul className="mt-8 grid sm:grid-cols-2 gap-x-6 gap-y-3">
                    {s.points.map(p => (
                      <li key={p} className="flex items-start gap-3 text-[15px] text-[#1A2530]">
                        <span className="w-5 h-5 mt-0.5 grid place-items-center bg-[#C5A059] text-white"><Check size={12}/></span>
                        {p}
                      </li>
                    ))}
                  </ul>

                  <div className="mt-10 flex flex-wrap gap-3">
                    <a href={SITE.telHref} className="btn-gold text-sm" data-testid={`service-${s.id}-call`}>
                      <Phone size={14}/> Call Us
                    </a>
                    <a href={SITE.whatsappHref} target="_blank" rel="noreferrer" className="btn-gold text-sm" data-testid={`service-${s.id}-whatsapp`}>
                      <MessageCircle size={14}/> Chat with Us
                    </a>
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </section>
    </div>
  );
}
